import { Component, Element, Prop, h } from '@stencil/core';

@Component({
  tag: 'dda-alert',
  styleUrls: ['dda-alert.css', '../../global/global.css', '../../global/dda-button.css'],
  shadow: false,
})
export class DdaAlert {
  @Prop() type: 'primary' | 'secondary' = 'primary';
  @Prop() variation: 'info' | 'warning' | 'error' | 'success' = 'info';
  @Prop() title_text: string = '';
  @Prop() description: string = '';
  @Prop() button_text: string = '';
  @Prop() custom_class?: string = ''; 
  @Prop() component_mode?: string; 
  @Element() el: HTMLElement;

  closeAlert() {
    const alert = this.el.querySelector('.dda-alert') as HTMLElement;
    alert.style.display = 'none';
  }

  render() {
    return (

      <div class={`dda-alert dda-alert-${this.type} dda-alert-${this.variation} ${this.custom_class} ${this.component_mode}`}>
        <i class="fa fa-circle-info info-icon"></i>
        <div class="alert-content">
          <h4 class="alert-title">{this.title_text}</h4>
          <p class="alert-description">{this.description}</p>
          <div class="alert-btn-wrap">
            <a href="#">Secondary</a>
            <a href="#">Primary</a>
            {/* <button class="dda-btn dda-btn-surface-link"><i class="fa-regular fa-face-smile icon-left"></i>{this.button_text}<i class="fa-solid fa-arrow-right icon-right"></i></button> */}
          </div>
        </div>
        <button class="dda-alert-close" onClick={() => this.closeAlert()}><i class="fa fa-xmark"></i></button>
      </div>

    );
  }
}